import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneFormatter]',
})
export class PhoneFormatterDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.startsWith('41')) {
      value = '+41 ' + value.substring(2);
    } else if (value.length > 0) {
      value = '+' + value;
    }
    if (value.length > 6) {
      value = value.substring(0, 6) + ' ' + value.substring(6);
    }
    if (value.length > 10) {
      value = value.substring(0, 10) + ' ' + value.substring(10);
    }
    if (value.length > 13) {
      value = value.substring(0, 13) + ' ' + value.substring(13);
    }
    if (value.length > 16) {
      value = value.substring(0, 16);
    }
    this.ngControl.control?.setValue(value, { emitEvent: false });
  }
}
